import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { ServicesSection } from '../components/ServicesSection';
import { HowItWorks } from '../components/HowItWorks';
import { CTABanner } from '../components/CTABanner';
import { SEO } from '../components/SEO';
export function ServicesPage() {
  const differentiators = ['Clinically skilled nursing leadership', 'RN-supervised care', 'Individualized care plans', 'All services provided in the comfort of home'];
  return <main data-id="element-547">
      <SEO title="Our Services | Personal, Skilled & Complex Care" description="Explore our comprehensive home health services including personal care, skilled nursing, dementia care, and Level 3 complex care in Columbia, MD." keywords="personal care services, skilled nursing home care, dementia care, Level 3 complex care" data-id="element-548" />
      <PageHero title="Services We Offer" subtitle="Comprehensive home health services tailored to your needs" data-id="element-549" />

      <ServicesSection data-id="element-550" />

      {/* What Sets Us Apart */}
      <section className="py-24 px-4 bg-white" data-id="element-551">
        <div className="max-w-7xl mx-auto" data-id="element-552">
          <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-553">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="flex-1" data-id="element-554">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-6" data-id="element-555">
                What Sets Us Apart
              </h2>
              <p className="text-lg text-neutral-medium mb-6 leading-relaxed" data-id="element-556">
                Unlike traditional agencies that send you to multiple locations
                for background checks, fingerprinting, and training,{' '}
                <strong className="text-primary" data-id="element-557">
                  we handle everything on-site.
                </strong>
              </p>
              <p className="text-lg text-neutral-medium mb-8 leading-relaxed" data-id="element-558">
                Our all-in-one facility is designed to make the certification
                process as fast and stress-free as possible for family
                caregivers. You can complete all requirements in one place,
                allowing you to focus on what matters most: caring for your
                loved one.
              </p>

              <ul className="space-y-4" data-id="element-559">
                {differentiators.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-560">
                    <CheckCircle2Icon className="w-6 h-6 text-accent flex-shrink-0" data-id="element-561" />
                    <span className="text-neutral-dark font-medium text-lg" data-id="element-562">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="flex-1" data-id="element-563">
              <div className="relative" data-id="element-564">
                {/* Primary photo */}
                <div className="rounded-3xl overflow-hidden shadow-xl" data-id="element-565">
                  <img src="https://cdn.magicpatterns.com/uploads/qVkwCzEK8fKzHzJ27wRNP2/image.png" alt="Caregiver assisting an elderly woman with crutches at home" className="w-full h-[360px] object-cover" data-id="element-566" />
                </div>

                {/* Secondary overlapping photo */}
                <div className="absolute -bottom-8 -right-4 w-48 h-48 rounded-2xl overflow-hidden shadow-lg border-4 border-white hidden md:block" data-id="element-567">
                  <img src="https://cdn.magicpatterns.com/uploads/o75542qQcm4f4UBYXzBFnM/image.png" alt="Caregiver smiling while assisting an elderly patient" className="w-full h-full object-cover" data-id="element-568" />
                </div>

                {/* Decorative accent */}
                <div className="absolute -top-4 -right-4 w-24 h-24 rounded-full border-2 border-accent/30 hidden md:block" data-id="element-569" />
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <HowItWorks data-id="element-570" />
      <CTABanner data-id="element-571" />
    </main>;
}